const generalErrorDataPush = () => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      error: {
        type: "technical-issue",
        message: "we've encountered an unexpected technical issue",
      },
    });
  }
};

export default generalErrorDataPush;
